export const STREET_FURNITURE_RENDER_CONFIG = Object.freeze({
  bollardHeightM: 0.78,
  bollardRadiusM: 0.085,
  wasteBasketHeightM: 0.92,
  wasteBasketWidthM: 0.42,
  bicycleRackRadiusM: 0.42,
  bicycleRackTubeRadiusM: 0.032,
  cabinetWidthM: 0.72,
  cabinetHeightM: 1.05,
  cabinetDepthM: 0.34,
  drainWidthM: 0.58,
  drainDepthM: 0.4,
  drainBarWidthM: 0.045,
  manholeRadiusM: 0.34,
  hydrantHeightM: 0.76,
  surfaceLiftM: 0.012,
});
